import React, { createRef, Component } from "react";


import { Map, WMSTileLayer, ScaleControl, Marker, GeoJSON, Pane, ImageOverlay } from "react-leaflet";
import {
  Button,
  Segment,
  Grid,
  Message,
  Icon,
  Popup,
  Menu,
} from "semantic-ui-react";

import L from "leaflet";
import Control from "react-leaflet-control";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExpand,
  faWindowClose,
  faChartBar,
  faCompress,
  faGlobeAsia,
  faInfoCircle,
  faThList,
} from "@fortawesome/free-solid-svg-icons";
import MouseControl from "../../MousePosition";

import domain from "../../domain";
import DateSlider from "./DateSlider";
import { isNull } from "util";
import colors from "../../colors";
import { FadeLoader } from "react-spinners";
import { connect } from "react-redux";
import {
  common_state,
  changeBaseLayer,
  displayBaseLayerPanel,
} from "../../redux_components/actions/CommonActions";
import { showInfo_f } from "../../redux_components/actions/ETActions";
import { OffCanvas, OffCanvasMenu } from "react-offcanvas";
import { MapContainer, TileLayer} from "react-leaflet";
//import { DraftControl } from "react-leaflet-draft";
import Drawtools from "./DrawToolNew";
import { EditControl } from "react-leaflet-draw";
import LeafletCompair from "./LeafletCompair"
//import Shapefile from "./Shapefile";




var parse = require("html-react-parser");

library.add(
  faWindowClose,
  faChartBar,
  faExpand,
  faCompress,
  faGlobeAsia,
  faInfoCircle,
  faThList
);

const units = {
  yAxis: {
    Evapotranspiration: "mm/day",
    Evapotranspiration_WB: "mm/day",
  },
};

const style = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

class MapView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pointInfo: null,

      legend: null,
      legendVisible: true,
      visibleRight: false,
      isExpand: false,

      activeDrags: 0,
      layerloading: false,
      markerenable: true,
      map: null,
      comparisonControl: null,
      showMap:true,

      // onClickDetails:{},
      // highlightState:null
      // selected:this.props.selected
    };
    this.mapRef = React.createRef();

  }
  mapRef = createRef();

  resetZoom = () => {
    const leafletMap = this.mapRef.current.leafletElement;
    leafletMap.setZoom(this.state.zoom);
    leafletMap.panTo(new L.LatLng(25.12539, 80.00164));
  };
  displayLegend = () => {
    this.setState({
      legendVisible: !this.state.legendVisible,
    });
  };
 
  componentDidMount() {
    let layer =
      this.props.selected !== null
        ? this.props.selected.toLowerCase().split(" ").join("-") +
        ":" +
        this.props.selectedLayer[this.props.selected]
        : "india states";

        console.log("lllllllllllllllllllllllllayer",layer)


    console.log("wms_urllllllllllllllllllselected",this.props.selected)



    let wms_url =
      this.props.selected !== null
        ? `${domain.Geoserver}/nhp_${this.props.selected
          .toLowerCase()
          .split(" ")
          .join("-")}/wms`
        : this.props.wms_url_base_layers;


        console.log("wms_urllllllllllllllllll",wms_url)
    this.props.common_state();
    const colors_range_et = [
      // "#ffffa0","#ffff78","#c0f766","#84ed48","#47de31","#58b660","#3cab80","#2595a9","#26659a","#203a77","#00ffff","#f6ffff","#c0c0c0"
      "#d6e4ff","#adc6ff","#85a5ff","#597ef7","#2f54eb","#2949cc","#1d39c4","#1d39c4","#10239e","#061178","#030852","#f0f5ff","#c7d1e6"
    ];
    const grades_et = [
      "0 - 1",
      "1 - 2",
      "2 - 3",
      "3 - 4",
      " 4 - 5",
      "5 - 6",
      "6 - 7",
      " 7 - 8",
      "8 - 9",
      "9 - 10",
      "10",
      "Cloud",
      "No Data",
    ];

    let img = grades_et.map((value, key) => {
      // console.log(index)
      return (
        <React.Fragment>
          <i key={key} style={{ background: `${colors_range_et[key]}` }}></i>{" "}
          {value} <br />{" "}
        </React.Fragment>
      );
    });
    this.getLegendGraphic(wms_url, layer).then((legend) => {
      console.log(layer);
      //   this.props.setLegend(legend);

      this.setState({
        legend: img,
      });

    });

    if (this.mapRef.current) {
      const leafletMap = this.mapRef.current.leafletElement;
      leafletMap.invalidateSize();
    }
}
  componentDidUpdate(prevProps, PrevState) {
    if (this.state.comparisonControl) {
      this.state.comparisonControl.remove();
    }
    let layer, layer_type;
    console.log("lllllllllllllllllllllllllselected",this.props.selected )

    // console.log(this.props.selected,prevProps.selected)
    if (this.props.selectedLayer !== prevProps.selectedLayer) {


      if(this.props.selected === "pet-Evapotranspiration") {
        //let selected=this.props.selected.split
        layer =
        this.props.selected !== null
          ? this.props.selected.toLowerCase().split(" ").join("-") +
          ":" +
          this.props.selectedLayer[this.props.selected]
          : "india states";
        
        layer_type = this.props.selectedLayer[this.props.selected].split(
            "_"
          )[3];
      } else if (this.props.selected === "pet-Evapotranspiration-Monthly750") {
        
        layer = this.props.mn_selectedLayer !== "" ? this.props.mn_selectedLayer : "india states";

        layer_type = this.props.selectedLayer[this.props.selected].split(
          "_"
        )[3];

      } else if (this.props.selected === "pet-Evapotranspiration-Fortnightly750") {
        layer = this.props.fn_selectedLayer !== "" ? this.props.fn_selectedLayer : "india states";

        layer_type = this.props.selectedLayer[this.props.selected].split(
          "_"
        )[3];
      }

      if (this.mapRef.current) {
        if (!this.props.visibleGraphPanel) {
          const leafletMap = this.mapRef.current.leafletElement;
          leafletMap.invalidateSize();
        }
      }
      if (this.props.visibleLeft === false) {
        const leafletMap = this.mapRef.current.leafletElement;
        leafletMap.invalidateSize();
      }
    

      console.log('LY1---------layer------', layer)
      console.log('PS------only props selected- not layer----------', this.props.selected)
      console.log('PSL---------props.selectedlayer-----', this.props.selectedLayer)
      
      
      console.log('LT1---layer_type----------------', layer_type)
      let wms_url =
        this.props.selected !== null
          ? `${domain.Geoserver}/nhp_evapotranspiration/wms`
          : this.props.wms_url_base_layers;
      console.log('LTW', wms_url);
      const colors_range_et = [
        "#ffffa0","#ffff78","#c0f766","#84ed48","#47de31","#58b660","#3cab80","#2595a9","#26659a","#203a77","#00ffff","#f6ffff","#c0c0c0"
        // "#d6e4ff","#adc6ff","#85a5ff","#597ef7","#2f54eb","#2949cc","#1d39c4","#1d39c4","#10239e","#061178","#030852","#f0f5ff","#c7d1e6"
      ];
      const grades_et = [
        // "0 - 1",
        // "1 - 2",
        // "2 - 3",
        // "3 - 4",
        // " 4 - 5",
        // "5 - 6",
        // "6 - 7",
        // " 7 - 8",
        // "8 - 9",
        // "9 - 10",
        // "10",
        // "Cloud",
        // "No Data",
        "0.0-0.5","0.5-1.0","1.0-1.5","1.5-2.0","2.0-2.5","2.5-3.0","3.0-3.5","3.5-4.0","4.0-4.5","4.5-5.0",">5.0","Cloud","No Data"
      ];

      let img = grades_et.map((value, key) => {
        // console.log(index)
        return (
          <React.Fragment>
            <i key={key} style={{ background: `${colors_range_et[key]}` }}></i>{" "}
            {value} <br />{" "}
          </React.Fragment>
        );
      });
      const colors_range_et_wb = [
        // "#ffffa0","#ffff78","#c0f766","#84ed48","#47de31","#58b660","#3cab80","#2595a9","#26659a","#203a77","#00ffff","#f6ffff","#c0c0c0"
        "#d6e4ff","#adc6ff","#85a5ff","#597ef7","#2f54eb","#2949cc","#1d39c4","#1d39c4","#10239e","#061178","#030852","#f0f5ff","#c7d1e6"
      ];
      const grades_et_wb = [
        "0 - 1",
        "1 - 2",
        "2 - 3",
        "3 - 4",
        " 4 - 5",
        "5 - 6",
        "6 - 7",
        " 7 - 8",
        "8 - 9",
        "9 - 10",
        "10",
      ];

      let img_wb = grades_et_wb.map((value, key) => {
        // console.log(index)
        return (
          <React.Fragment>
            <i
              key={key}
              style={{ background: `${colors_range_et_wb[key]}` }}
            ></i>{" "}
            {value} <br />{" "}
          </React.Fragment>
        );
      });
      const colors_range_et_mai = [
        // "#ffffa0","#ffff78","#c0f766","#84ed48","#47de31","#58b660","#3cab80","#2595a9","#26659a","#203a77","#00ffff","#f6ffff","#c0c0c0"
        "#c2523c", "#d66f2b", "#eda113","#f5ca0c",  "#ffff00" ,  "#7bed00","#00db00",  "#14ba5f" ,  "#20998f",  "#16678a", "#FFFFFF",
      ];
      const grades_et_mai = [
        "00 - 10","10 - 20",
        "20 - 30",
        "30 - 40",
        "40 - 50",
        "50 - 60",
        "60 - 70",
        "70 - 80",
        "80 - 90",
        "90 - 100",
        "Cloud",
      ];

      let img_mai = grades_et_mai.map((value, key) => {
        // console.log(index)
        return (
          <React.Fragment>
            <i
              key={key}
              style={{ background: `${colors_range_et_mai[key]}` }}
            ></i>{" "}
            {value} <br />{" "}
          </React.Fragment>
        );
      });

      const colors_range_et_esi = [
        // "#ffffa0","#ffff78","#c0f766","#84ed48","#47de31","#58b660","#3cab80","#2595a9","#26659a","#203a77","#00ffff","#f6ffff","#c0c0c0"
        //"#c2523c", "#d66f2b", "#eda113","#f5ca0c",  "#ffff00" ,  "#7bed00","#00db00",  "#14ba5f" ,  "#20998f",  "#16678a", "#FFFFFF",
        "#872626",   "#ad4f23",  "#d97c18" , "#f7a934", "#ffd175", "#ffffbf", "#b9b2bf", "#726eba" ,"#4045a8",  "#353191", "#27207a","#FFFFFF",
      ];
      const grades_et_esi= [
        "-3.0 - -2.5",
        "-2.5 - -2.0" ,
        "-2.0 - -1.5" ,
        "-1.5 - -1.0",
        "-1.0 - -0.5" ,
        "-0.5 -  0.0",     
        "0.0 -  0.5" ,   
        "0.5 -  1.0" ,   
        "1.0 -  1.5" , 
        "1.5 -  2.0", 
        "2.0 -  2.5",
        "Cloud",
      ];

      let img_esi = grades_et_esi.map((value, key) => {
        // console.log(index)
        return (
          <React.Fragment>
            <i
              key={key}
              style={{ background: `${colors_range_et_esi[key]}` }}
            ></i>{" "}
            {value} <br />{" "}
          </React.Fragment>
        );
      });

      this.getLegendGraphic(wms_url, layer).then((legend) => {
        console.log(layer,layer_type,"layertypeeeeeee",this.props.selected.split("-")[0]);
        //   this.props.setLegend(legend);
        if(this.props.selected.split("-")[0]==="mai")
        {
          //console.log("maiiiiiiiiii")
        this.setState({
          legend: img_mai,
        });
      }
      if(this.props.selected.split("-")[0]==="esi")
        {
          //console.log("maiiiiiiiiii")
        this.setState({
          legend: img_esi,
        });
      }
        if (layer_type === "WB") {
          this.setState({
            legend: img_wb,
          });
        } if(this.props.selected.split("-")[0]==="et" ||this.props.selected.split("-")[0]==="pet") {
          //console.log("maiiiiiii   eelse")
          this.setState({
            legend: img,
          });
        }
      });

    }

 
  }

  async getLegendGraphic(wms_url, layer) {
    let request = "GetLegendGraphic";
    let format = "image/png";
    let width = 20;
    let height = 10;
    let fontName = "Serif";

    let img_src = `${wms_url}?request=${request}&layer=${layer}&format=${format}&width=${width}&height=${height}&legend_options=fontName:${fontName}`;
    console.log("imgggggggg",img_src)
    return img_src;
  }

  handleAnimationChangeRight = () => {
    this.setState({
      visibleRight: !this.state.visibleRight,
      // width: !this.state.visible?"76.5%":"100%"
    });
  };
  handleExpand = () => {
    this.setState({
      isExpand: !this.state.isExpand,
    });
  };

  highlightState = (feature, layer) => {
    layer.setStyle({
      weight: 3,
      color: "#828faf",
      fillOpacity: 0,
    });
  };
  handleMark = () => {
    this.setState({ markerenable: true });
  };
  loading = (e) => {
    this.setState({
      layerloading: true,
    });
    // console.log(e)
  };
  load = (e) => {
    this.setState({
      layerloading: false,
    });
  };
  highlightBasinRiverSub = (feature, layer) => {
    const map = this.mapRef.current.leafletElement;

    console.log(feature,"RRRRRRRRRRRRRRRRRRRRRRRRRRR",layer)
    console.log(map);
    layer.setStyle({
      color: 'blue', // Set color to transparent
      weight: 2,  
      fill:false,

      fillOpacity: 0,
      
    });
    

    // map.fitBounds(layer.getBounds(),{ maxZoom:6})

    map.flyToBounds(layer.getBounds(), {
      animate: true, // Enables animation
      duration: 1,   // Duration in seconds (adjust as needed)
      easeLinearity: 0.25, 
       maxZoom:6// Controls easing (default is 0.25, lower makes it smoother)
    //  padding: [50, 50] // Adds some padding around the bounds
    });
  
  };
  handleMapClick = (latlng) => {
    // Your existing code to handle the onclick event and generate the time series chart
    console.log("Map clicked at:", latlng);
    // Implement your logic to generate the time series chart here
  };
  handleTouchStart = (e) => {
    this.swipeRef.startX = e.touches[0].clientX;
    this.swipeRef.startY = e.touches[0].clientY;
    this.swipeRef.dragging = true;
  };

  handleTouchMove = (e) => {
    if (!this.swipeRef.dragging) return;

    const deltaX = e.touches[0].clientX - this.swipeRef.startX;
    const deltaY = e.touches[0].clientY - this.swipeRef.startY;

    this.mapRef.current.leafletElement.panBy(new L.Point(-deltaX, -deltaY), { animate: false });

    this.swipeRef.startX = e.touches[0].clientX;
    this.swipeRef.startY = e.touches[0].clientY;
  };
  
 

  handleTouchEnd = () => {
    this.swipeRef.dragging = false;
  };
  highlightState = (feature, layer) => {
    // const map = this.mapRef.current.leafletElement
    const map = this.mapRef.current.leafletElement;
    // console.log(feature.properties);
    layer.setStyle({
      weight: 2,
      color: 'transparent',
      fillOpacity: 0,
      // fill:false
    });

    layer.on({
      mouseover: (event) => {
        layer.setStyle({
          weight: 3,
          color: "transparent",
          fillOpacity: 0,
          //  fill:false
        });
      },
      mouseout: (event) => {
        layer.setStyle({
          weight: 3,
          color: 'transparent',
          fillOpacity: 0,
          //  fill:false
        });
      },
    });
    let string = feature.properties.state !== "undefined"

      ? feature.properties.state : ''
    // console.log(string)
    // let label = L.marker(layer.getBounds().getCenter(), {
    //   icon: L.divIcon({
    //     className: "label",
    //     html: `<h5 color='red'>${string}</h5>`,
    //     iconSize: [40, 40],
    //   }),
    // }).addTo(map);
    // if (label !== undefined) {
    //   map.removeLayer(label);
    // }

  };

  render() {
    let test,testunit,activedate, layer, layer_type , product, product_actual;

console.log("this.props.timeserieschartdata",this.props.timeserieschartdata)
    console.log("this.props.pointInfo",this.props.pointInfo)
    let layerr="Evapotranspiration"
    console.log("pointinfo",this.props.pointInfo)   
    console.log("this.props.visibleGraphPanel",this.props.visibleGraphPanel)
    console.log("collapseddddddd",this.props.collapsed4,this.props.collapsed)
    console.log("this.props.selectedddddd",this.props.selected,this.props.selectedLayer[this.props.selected])
    console.log("geojson dataaaaa",this.props.shapefileData)
    console.log("custommmmmm",this.props.customshapeselected)
    console.log("collapsed1",this.props.collapsed1)
    if(   this.props.shapefileData!==null          ){
      const geometry = this.props.shapefileData.features.map(feature => feature.geometry);
      console.log("geojson dataaaaa geojson dataaaaa",geometry )
    }
  

    if( this.props.selected !== null){
    product_actual=(this.props.selected).split("-")[0]
     console.log("producttttttt",product_actual)
     if(product_actual==="et"){
      product=""
     }
     else{
      product=product_actual+"_"
     }
     console.log("producttttttt",product_actual,product)


    }
    if(this.props.selected === "et-Evapotranspiration"|| this.props.selected === "pet-Evapotranspiration"||this.props.selected === "mai-Evapotranspiration"||this.props.selected === "esi-Evapotranspiration") {
      layer =
      this.props.selected !== null
        ? this.props.selected.toLowerCase().split(" ").join("-") +
        ":" +
        this.props.selectedLayer[this.props.selected]
        : "india states";
      
      layer_type = this.props.selectedLayer[this.props.selected].split(
       "_"
        )[3];
    } else if (this.props.selected === "et-Evapotranspiration-Monthly750"||this.props.selected === "pet-Evapotranspiration-Monthly750"||this.props.selected === "mai-Evapotranspiration-Monthly750"||this.props.selected === "esi-Evapotranspiration-Monthly750") {
      
      layer = this.props.mn_selectedLayer !== "" ? "evapotranspiration:"+this.props.mn_selectedLayer : "india states";

      layer_type = this.props.selectedLayer[this.props.selected].split(
        "_"
      )[3];

    } else if (this.props.selected === "et-Evapotranspiration-Fortnightly750"||this.props.selected === "pet-Evapotranspiration-Fortnightly750"||this.props.selected === "mai-Evapotranspiration-Fortnightly750"||this.props.selected === "esi-Evapotranspiration-Fortnightly750") {
      layer = this.props.fn_selectedLayer !== "" ? "evapotranspiration:"+this.props.fn_selectedLayer : "india states";

      layer_type = this.props.selectedLayer[this.props.selected].split(
        "_"
      )[3];
    }

    delete L.Icon.Default.prototype._getIconUrl;
    // console.log(this.props.india_states_boundary);
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    });
    console.log("layer for wms",{layer},layer)

 if(this.props.selected!==null){
    if (this.props.selected.split("-")[0] === "et" || this.props.selected.split("-")[0] === "pet") {
      test = "Evapotranspiration";
      testunit="(mm/day)"
      activedate=this.props.activeDate
    }
    if (this.props.selected.split("-")[0] === "mai" ) {
      test = "Moisture Adequacy Index";
      testunit="( % )"
      activedate=""

    }
    if (this.props.selected.split("-")[0] === "esi" ) {
      test = "Evaporative Stress Index";
      testunit=""
      activedate=""

    }
    
    
    else if (this.props.selected === "Evapotranspiration_WB") {
      test = "Evapotranspiration (WB)";
    }
  }
    //else if (this.props.selected === "Pet Evapotranspiration") {
    //  test = "PET-Evapotranspiration";}

     // else if (this.props.selected === "MAI Evapotranspiration") {
      //  test = "MAI-Evapotranspiration";}
       // else if (this.props.selected === "ESI Evapotranspiration") {
       //   test = "ESI-Evapotranspiration";}


          

    return (
      <>
        {this.state.showMap && !this.props.collapsed4 && (
      <Map
        ref={this.mapRef}
        center={this.props.center}
        minZoom={this.props.minZoom}
        maxZoom={this.props.maxZoom}
        zoom={this.props.zoom}
        //onclick={this.handleMapClick} 
        //onclick={this.props.onMapClick} 
        onclick={this.props.collapsed === true ? this.props.onMapClick : null}

        style={{ backgroundColor: "#fff" }}
        attributionControl={this.props.attributionControl}
        crs={this.props.crs}
      
      >
       
        {this.props.baselayerselected !== null ? (
          <WMSTileLayer
            ref={this.tileRef}
            layers={this.props.layers}
            url={this.props.url}
            format="image/png"
            transparent={true}
            zIndex={1}
            onloading={this.loading}
            onload={this.load}
          />
        ) : null}

{this.props.customshapeselected==="draw" && this.props.collapsed1?

        <Drawtools onSave={this.props.handleSaveGeoJSON }/>

        :null
      }

     
        {this.props.india_states_boundary !== null ?

          <Pane className="GridcellsPane">
            {" "}
            <GeoJSON
              ref="geojson"
              key={this.props.india_states_boundary.features[0].id}
              data={this.props.india_states_boundary}
              onEachFeature={this.highlightState}
            // crs={crs}
            // zIndex={10}
            // transparent={true}
            />
          </Pane> : null
        }
           {this.props.shapefileData && <GeoJSON data={this.props.shapefileData} 
             onEachFeature={this.highlightBasinRiverSub}
            
           />}
         {this.props.boundary !== null ?

            <GeoJSON
              ref="geojson"
              key={this.props.boundary.features[0].id}
              data={this.props.boundary}
              onEachFeature={this.highlightBasinRiverSub}

            />
            : null}
        
        {/* {this.props.selected !== null ? (
          <WMSTileLayer
            url={`${
              domain.Geoserver
              }/nhp_${this.props.selected
                .toLowerCase()
                .split(" ")
                .join("-")}/wms`}
            layers={
              "nhp_" +
              this.props.selected.toLowerCase().split(" ").join("-") +
              ":" +
              this.props.selectedLayer[this.props.selected]
            }
            format="image/png"
            zIndex={5}
            transparent={true}
            onloading={this.loading}
            onload={this.load}
          // interpolations="nearest neighbor"
          // format_options="dpi:300"
          // opacity={1}
          // crs={ crs}
          />
        ) : null} */}
       

{this.props.selected !== null && this.props.collapsed? (
   
       
          <WMSTileLayer
            url={`${
              domain.Geoserver
              }/nhp_${product}evapotranspiration/wms`}
            layers={
              "nhp_"+ layer
            }
            format="image/png"
            zIndex={5}
            transparent={true}
            onloading={this.loading}
            onload={this.load}
          // interpolations="nearest neighbor"
          // format_options="dpi:300"
          // opacity={1}
          // crs={ crs}
          />
            
        ) : null}
     

        {(this.props.latlng !== null && this.props.collapsed===true) ? (
          <Marker position={[this.props.latlng.lat, this.props.latlng.lng]} />
        ) : null}
  
        {this.props.metadata ? (
          <Control position="topleft">
            <Segment
              style={{
                marginLeft: "44px",
                marginTop: "-200px",
                width: window.innerWidth - (260 + 46 + 100),
                minHeight: window.innerHeight - 600,
              }}
            >
              <Grid
                columns="equal"
                divided
                style={{ marginLeft: "10rem", marginRight: "-3rem" }}
              >
                <Grid.Row style={{ paddingTop: "0em", paddingBottom: "0em" }}>
                  <Grid.Column>
                    <Button
                      basic
                      size="tiny"
                      floated="right"
                      compact
                      style={{ padding: "2px" }}
                      onClick={this.handlePopupClose}
                    >
                      <FontAwesomeIcon icon="window-close" size="lg" />
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>
          </Control>
        ) : null}

        <Control position="topleft">
          <Popup
            trigger={
              <Button
                size="tiny"
                onClick={this.resetZoom}
                compact
                style={{ padding: "8px" }}
              >
                <FontAwesomeIcon icon="globe-asia" size="lg" />
              </Button>
            }
            position="right center"
          >
            <Popup.Content>Reset Zoom</Popup.Content>
          </Popup>
        </Control>
        {this.state.layerloading ? (
          <Control position="topleft">
            <div style={style}>
              <FadeLoader
                height="20"
                radius="3"
                margin="3"
                width="10"
                // css={override}
                sizeUnit={"px"}
                // size={150}
                color={"#123abc"}
                loading={this.state.layerloading}
              />
            </div>
          </Control>
        ) : null}
        <Control position="topleft">
          <div>
            {(this.props.showInfo && this.props.collapsed===true) ? (
              <div
                style={{
                  marginRight: "0px",
                  paddingLeft: "0rem",
                  paddingRight: "0rem",
                  marginLeft: "0px",
                }}
              >
                <Button
                  basic
                  attached="right"
                  floated="right"
                  size="tiny"
                  compact
                  style={{ padding: "5px" }}
                  onClick={this.props.showInfo_f}
                  color={isNull(this.props.pointInfo) ? "brown" : "teal"}
                >
                  <FontAwesomeIcon icon="window-close" size="lg" />
                </Button>
                <Message
                  icon="map marker alternate"
                  info
                  warning={isNull(this.props.pointInfo)}
                  attached="bottom"
                >
                  <Icon name="map marker alternate" />
                  {(this.props.pointInfo !== null && this.props.collapsed===true) ?(
                    <Message.Content>
             <Message.Header>{this.props.selected.split("-")[0]=== "et" ? "AET":this.props.selected.split("-")[0]==="pet"? "PET":null}</Message.Header>
                      <b>Date:</b>&nbsp;{this.props.activeDate}
                      <br />
                      {isNull(this.props.pointInfo) ? (
                        <div>
                          <b>Data not available in this region</b>
                        </div>
                      ) : (
                          <div>
                            <b>Value:</b>&nbsp;{this.props.pointInfo}{" "}

                            {this.props.pointInfo !== "Cloud"
                              ? 'mm/day'
                              : null}
                          </div>
                        )}
                      <b></b>
                      {/* <b>State:</b>&nbsp;{this.props.stateInfo.geojson.properties.STATE.toLowerCase().split(' ').map((word)=> word.replace(word[0], word[0].toUpperCase())).join(' ')} */}
                    </Message.Content>
                  ) : (
                      "Select a place within Indian boundary"
                    )}
                </Message>
              </div>
            ) : (
                <Popup
                  trigger={
                    <Button
                      size="tiny"
                      compact
                      style={{ padding: "8px" }}
                      onClick={this.props.showInfo_f}
                    >
                      <FontAwesomeIcon icon="info-circle" size="lg" />
                    </Button>
                  }
                  position="right center"
                >
                  <Popup.Content>
                    click this to know about what is in the point you clicked in
                    the map
                </Popup.Content>
                </Popup>
              )}
          </div>
        </Control>
        {window.innerWidth > 1000 ?
          <Control position="topleft">
            <Button
              onClick={this.props.handleAnimationChange}
              secondary
              style={{ backgroundColor: colors.sidebar, marginLeft: "-10px" }}
              attached="right"
              compact
              size="mini"
            >
              <FontAwesomeIcon icon="th-list" size="sm" />
            </Button>
          </Control> : <Control position="bottomleft">
            <Button
              onClick={this.props.handleAnimationChange}
              secondary
              style={{ backgroundColor: colors.sidebar, marginLeft: "-10px" }}
              attached="right"
              compact
              size="mini"
            >
              <FontAwesomeIcon icon="th-list" size="sm" />
            </Button>
          </Control>}


        <Control position="bottomright">
          <OffCanvas
            width={180}
            transitionDuration={300}
            effect={"overlay"}
            style={{ cursor: "pointer" }}
            isMenuOpened={this.state.isMenuOpened}
            position={"right"}
          >
            <OffCanvasMenu
              style={{
                alignContent: "center",
                backgroundColor: "rgba(255,255,255,0.5)",
                borderColor: "blue",
                top: "10px",
                marginRight: "10px",
                transform: "translate(-180px, 0px)",
              }}
            >
              <div>
                <div style={{ background: colors["final_side"] }}>
                  <Menu.Item
                    as="div"
                    onClick={this.props.displayBaseLayerPanel}
                    style={{
                      textAlign: "center",
                      marginLeft: `5px`,
                      cursor: "pointer",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          width: "80%",
                          color: colors.textcolor,
                          fontSize: "small",
                          cursor: "default",
                        }}
                      >
                        Base Layers
                      </div>
                      <div
                        style={{
                          textAlign: "right",
                          width: "20%",
                          marginRight: "10px",
                        }}
                      >
                        {this.props.baseLayers ? (
                          <FontAwesomeIcon icon="angle-down" />
                        ) : (
                            <FontAwesomeIcon icon="angle-right" />
                          )}
                      </div>
                    </div>
                  </Menu.Item>
                </div>
                {this.props.baseLayers ? (
                  <div>
                    <input
                      type="radio"
                      name="baselayer"
                      value="Satellite"
                      checked={this.props.baselayerselected === "Satellite"}
                      onChange={this.props.changeBaseLayer}
                    />{" "}
                    Satellite <br />
                    <input
                      type="radio"
                      name="baselayer"
                      value="Map"
                      checked={this.props.baselayerselected === "Map"}
                      onChange={this.props.changeBaseLayer}
                    />{" "}
                    Map
                  </div>
                ) : null}
                <div style={{ background: colors["final_side"] }}>
                  <Menu.Item
                    as="div"
                    onClick={this.displayLegend}
                    style={{
                      textAlign: "center",
                      marginLeft: `5px`,
                      cursor: "pointer",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          width: "80%",
                          color: colors.textcolor,
                          fontSize: "small",
                        }}
                      >
                        Legend
                      </div>
                      <div
                        style={{
                          textAlign: "right",
                          width: "20%",
                          marginRight: "10px",
                        }}
                      >
                        {this.state.legendVisible ? (
                          <FontAwesomeIcon icon="angle-down" />
                        ) : (
                            <FontAwesomeIcon icon="angle-right" />
                          )}
                      </div>
                    </div>
                  </Menu.Item>
                </div>

                {this.state.legendVisible ? (
                  <React.Fragment>
                {/* <center style={{  backgroundColor:colors.final_side_sub}}> */}
                  <center>  
                      {test ? (
                        <p
                          style={{
                            textAlign: "center",
                            fontWeight: "600",
                            fontSize: "14px",
                          }}
                        >
                          {" "}
                          {test && (
                            <div>
                              {test} <br/>
                            </div>
                          )}
                          {testunit && (
                            <div>
                              {testunit} <br/>
                            </div>
                          )}
                          {activedate && (
                            <div>
                              {activedate} <br/>
                            </div>
                          )}
                        </p>
                      ) : null}
                      <div className="info legend">{this.state.legend}</div>

                      {/* <img src={this.state.legend} alt='' /> */}
                    </center>
                  </React.Fragment>
                ) : null}
              </div>
              <div></div>
            </OffCanvasMenu>
          </OffCanvas>
        </Control>

        {!this.props.visibleGraphPanel && this.props.chartData !== null ? (
          <Control position="bottomright">
            <Popup
              trigger={
                <Button
                  onClick={this.props.toggleVisibleGraphPanel}
                  secondary
                  style={{ backgroundColor: colors.sidebar }}
                  compact
                  size="medium"
                >
                  <FontAwesomeIcon icon="chart-bar" size="lg" />
                </Button>
              }
              position="left center"
            >
              <Popup.Content>Graphical Analysis</Popup.Content>
            </Popup>
          </Control>
        ) : null}
        {!this.props.visibleGraphPanel1  ? (
          <Control position="bottomright">
            <Popup
              trigger={
                <Button
                  onClick={this.props.toggleVisibleGraphPanel1}
                  secondary
                  style={{ backgroundColor: colors.sidebar }}
                  compact
                  size="medium"
                >
                  <FontAwesomeIcon icon="chart-bar" size="lg" />
                </Button>
              }
              position="left center"
            >
              <Popup.Content>Graphical Analysis for timeseries</Popup.Content>
            </Popup>
          </Control>
        ) : null}



          <Control
            position="bottomleft"
            style={{ pointerEvents: "auto", cursor: "auto" }}
            >


        {
          (this.props.selected === 'et-Evapotranspiration'|| this.props.selected ==='pet-Evapotranspiration') ?
          (
            
              <DateSlider {...this.props.sliderOptions} />

          )

          : null
        }
          </Control>        
        <MouseControl position="bottomleft" />
        <ScaleControl metric={true} />
      </Map>
        )}

{this.props.collapsed4 && ( // Render LeafletCompair when collapsed4 is true
          <LeafletCompair
          //ref={this.mapRef}
          productselected={this.props.productselected}
          timestampselected={this.props.timestampselected}
          compareLeftDate={this.props.compareLeftDate}
          compareLeftWorkspace={this.props.compareLeftWorkspace}
          compareLeftLayer={this.props.compareLeftLayer}
          selectedLayer={this.props.selectedLayer}
          selected={this.props.selected}
          fn_selectedLayer={this.props.fn_selectedLayer}
          mn_selectedLayer={this.props.mn_selectedLayer}
          //productselected={this.props.productselected}
          productselectedR={this.props.productselectedR}
          stopVisualisationLeft={this.props.stopVisualisationLeft}
          stopVisualisationRight={this.props.stopVisualisationRight}

          compare_fn_selectedFN={this.props.compare_fn_selectedFN}
          compare_fn_selectedFNR={this.props.compare_fn_selectedFNR}
          compare_fn_selectedMonth={this.props.compare_fn_selectedMonth}
          compare_fn_selectedMonthR={this.props.compare_fn_selectedMonthR}
          compare_fn_selectedYear={this.props.compare_fn_selectedYear}
          compare_fn_selectedYearR={this.props.compare_fn_selectedYearR}
          compare_mn_selectedMonth={this.props.compare_mn_selectedMonth}
          compare_mn_selectedMonthR={this.props.compare_mn_selectedMonthR}
          compare_mn_selectedYear={this.props.compare_mn_selectedYear}
          compare_mn_selectedYearR={this.props.compare_mn_selectedYearR}
         // timestampselected={this.props.timestampselected}
          timestampselectedR={this.props.timestampselectedR}



          compareRightDate={this.props.compareRightDate}
          handleAnimationChange={this.props.handleAnimationChange}


          compareRightWorkspace= {this.props.compareRightWorkspace}// !== null ? this.props.compareRightWorkspace : undefined}
          compareRightLayer= {this.props.compareRightLayer }//!== null ? this.props.compareRightLayer : undefined}
          legend={this.state.legend}

          //selected={this.props.selected}
         // center={this.props.center}
         // minZoom={this.props.minZoom}
          //maxZoom={this.props.maxZoom}
          //zoom={this.props.zoom}
          onclick={this.handleMapClick} 
          style={{ backgroundColor: "#fff" }}
          attributionControl={this.props.attributionControl}
          //displayBaseLayerPanel={this.props.displayBaseLayerPanel}
          crs={this.props.crs}
          ref={this.tileRef}
          layers={this.props.layers}
          url={this.props.url}
          format="image/png"
          transparent={true}
          //zIndex={1}
          onloading={this.loading}
          boundary={this.props.india_states_boundary}
          onload={this.load}
            wms2Url={`${domain.Geoserver}/nhp_${product}evapotranspiration/wms`}
            wms2Layers={`nhp_${layer}`}
            center={this.props.center}
            zoom={10}
            zIndex={500} 
            isMenuOpened={this.state.isMenuOpened}
            baselayerselected={this.props.baselayerselected}
            displayBaseLayerPanel={this.props.displayBaseLayerPanel}
            baseLayers={this.props.baseLayers}
            changeBaseLayer={this.props.changeBaseLayer}
           
            collapsed4={this.props.collapsed4}
          />
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    minZoom: state.CState.minZoom,
    maxZoom: state.CState.maxZoom,
    center: state.CState.indiamapcenter,
    zoom: state.CState.zoom,
    url: state.CState.url,
    layers: state.CState.layers,
    baselayerselected: state.CState.baselayerselected,
    attributionControl: state.CState.attributionControl,
    crs: state.CState.crs,
    baseLayers: state.CState.baseLayers,
    chartData: state.ETState.chartData,
  };
};
export default connect(mapStateToProps, {
  common_state,
  changeBaseLayer,
  displayBaseLayerPanel,
  showInfo_f,
})(MapView);
